<template>
  <donut-chart-card
    :size="size"
    title="중대시민재해 대상 시설 현황"
    :value="data"
    unit="개소"
    :isMoveWrite="isMoveWrite"
    :orientation="orientation"
    @detail="onClickDetail"
    @write="onClickWrite"
    @item="onClickItem"
  ></donut-chart-card>
</template>

<script>
import DonutChartCard from '@/components/DonutChartCard'

export default {
  name: 'DonutChart21',
  components: {DonutChartCard},
  props: {
    dataType: 'detail' | 'field' | 'address' | 'field_cat1' | 'company' | 'project',
    size: String,
    reloadCount: Number,
    orientation: {
      type: "landscape" | "portrait",
      default: () => "portrait"
    },
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    projectInfo () {
      return this.$store.state.project.projectInfo

    },
  },
  watch: {
    dataType (/*value*/) {
      this.loadGraph()
    },
    reloadCount () {
      this.loadGraph()
    }
  },
  data () {
    return {
      graphId: 21,
      isMoveWrite: false,
      data: [{label: '데이터 없음', value: 0}],
    }
  },
  async mounted () {
    await this.loadGraph()
  },
  methods: {
    async loadGraph () {
      if (this.projectId > 1) {
        await this.loadGraphCompany()
      } else {
        await this.loadGraphFieldType()
      }
    },
    async loadGraphFieldType () {
      const data = await this.$store.dispatch('summary/LOAD_SUMMARY_FIELD', {})
      let keys = Object.keys(data)
      keys = keys.filter((value) => {
        return (value === '사업장(원료, 제조물)' || value === '시설물')
      })
      if (keys && keys.length > 0) {
        const list = keys.map((value) => {
          return {label: this.changeFieldType(value), value: data[value].total}
        })

        list.sort((a, b) => {
          if (a.value > b.value) return -1
          else if (a.value < b.value) return 1
          else return 0
        })

        this.data = list
      }
    },
    changeFieldType(fieldType) {
      switch (fieldType) {
      case '사업장(원료, 제조물)':
        return '원료·제조물 사업장';
      default:
        return fieldType;
      }
    },
    async loadGraphCompany () {
      const options = { projectId: this.projectId }
      if (Number(this.projectId) === 5) {
        options.fieldCode = 'workplace-material'
      }
      const data = await this.$store.dispatch('summary/LOAD_SUMMARY_FIELD_COMPANY', options)
      const root_company_id = this.projectInfo.root_company_id
      if (data && data.length > 0) {
        const list = []
        for (const com of data) {
          if (com.info.id !== root_company_id) {
            list.push({label: com.info.com_name, value: com.count})
          }
        }
        this.data = list
      }
    },
    onClickDetail () {
      const projectId = this.$route.params.proj_id
      const graphId = this.graphId
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph-detail/${graphId}`)
      } else {
        this.$router.push(`/graph-detail/${graphId}`)
      }
    },
    onClickWrite () {
      const proj_id = this.$route.params.proj_id
      this.$router.push({name: 'field-workplace-create', params: {proj_id}})
    },
    onClickItem () {
      if (Number(`${this.projectId}`) === 2) {
        this.$router.push('/project/1/field/info/type-a')
      } else if (Number(`${this.projectId}`) === 3) {
        this.$router.push('/project/1/field/info/type-b')
      } else if (Number(`${this.projectId}`) === 4) {
        this.$router.push('/project/1/field/info/type-c')
      } else if (Number(`${this.projectId}`) === 5) {
        this.$router.push('/project/1/field/info/type-d')
      }
    }
  },
}
</script>

<style scoped>

</style>
